export enum SIDE_PANEL_SIZE {
  _400 = "400px",
  _720 = "720px",
  _900 = "900px"
}
